import React from "react";
import { Layout } from "antd";
import "./WidgetLayout.scss";

const WidgetLayout = (props) => {
  return <Layout>{props.children}</Layout>;
};

export default WidgetLayout;
